import type { IFeedback } from "../contexts/global-ctx";

export const BASE_API =
    process.env.NODE_ENV === "development"
        ? "http://localhost:8080/api"
        : "/api";

export const NOT_CONNECTED_MESSAGE =
    "You are not connected to the internet. Make sure you have a working connection.";

export let appVersion = 0.8;

export const INITIAL_FEEDBACK: IFeedback = {
    loading: false,
    show: false,
    message: {
        title: "",
    },
    severity: undefined,
};

export const ADMS_APP_MASTER_KEY = "shahidahmadkhan1234";

// export const org_api_key_map: { [org_code: string]: string } = {
//     ZSPVTLTD: "1f9603c0-02da-4821-8162-d964a7457c0e",
//     smc: "1925ef0c-8e77-448e-971c-fa30cc16513c",
//     alkhairbuner: "1d3a3469-aaf1-4d3b-824b-a6b2935533ab",
//     stmc: "2bbaa1e8-7d74-4fbc-aa17-d93f9f5e6dd3",
//     smartkanju: "86a0aff4-a85f-4d5d-9806-10ebe9c1f796",
// };

export enum PERMISSIONS {
    // USER
    CREATE_USER = "CREATE USER",
    READ_USER = "READ USER",
    UPDATE_USER = "UPDATE USER",
    ARCHIVE_USER = "ARCHIVE USER",
    // ATTENDANCE
    READ_ATTENDANCE = "READ ATTENDANCE",
    // BRANCH
    CREATE_BRANCH = "CREATE BRANCH",
    UPDATE_BRANCH = "UPDATE BRANCH",
    READ_BRANCH = "",
    ARCHIVE_BRANCH = "ARCHIVE BRANCH",
    // DEVICE
    CREATE_DEVICE = "CREATE DEVICE",
    UPDATE_DEVICE = "UPDATE DEVICE",
    ARCHIVE_DEVICE = "ARCHIVE DEVICE",
    READ_DEVICE = "READ DEVICE",
    SYNC_DEVICE_USERS = "",
    SYNC_DEVICE_ATTENDANCE = "",

    // ORGANIZATION
    CREATE_ORGANIZATION = "CREATE ORGANIZATION",
    UPDATE_ORGANIZATION_STATUS = "UPDATE ORGANIZATION_STATUS",
    ARCHIVE_ORGANIZATION = "ARCHIVE ORGANIZATION",
    READ_ORGANIZATION = "READ ORGANIZATION",
}
